"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledUtils = require("./utils/StyledUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Use && to increase the specificity of the CSS to override MUI styling
var Div = _styledComponents["default"].div.withConfig({
  displayName: "Box__Div",
  componentId: "sc-10i92mo-0"
})(["&&{", " ", " ", " ", " ", " ", " ", " ", "}"], _styledSystem.border, _styledSystem.color, _styledSystem.layout, _styledSystem.flexbox, _styledSystem.position, _styledSystem.shadow, _styledSystem.space, _styledSystem.typography);

var Box = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var component = props.component,
      mui = props.mui,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["component", "mui", "children"]); // I had a hard time mimicking the behaviour of the MUI component prop
  // so I gave up; in the RARE cases it's used, fall back to the MUI Box


  if (component || mui) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-props-no-spreading
      _react["default"].createElement(_Box2["default"], _extends({
        component: component
      }, otherProps), children)
    );
  }

  var newProps = (0, _StyledUtils.scaleSpaceProps)(otherProps);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react["default"].createElement(Div, _extends({
      ref: ref
    }, newProps), children)
  );
});

var _default = Box;
exports["default"] = _default;